// decorators.ts
import { Validator } from "./validator.js";
var validateSymbol = Symbol("validationTargetProtoReference");
function validate(validationFunction) {
  return (target, propertyName) => {
    let validator = target.validator;
    if (!validator)
      validator = new Validator({ [validateSymbol]: target });
    if (validator.functions[validateSymbol] !== target)
      validator = new Validator({ ...validator.functions, [validateSymbol]: target });
    validator.functions[propertyName] = validationFunction;
    target.validator = validator;
  };
}
export {
  validate,
  validateSymbol
};
